<template>
<div id="home">
    <!-- 首页头部滚动 -->
    <!-- <swiperTop :key="scrollBanners.length">
        <div class="swiper-slide" v-for="item in scrollBanners" :key="item.id" >
            <a v-if="item.src != null" :href="item.src"><img :src="item.img" :alt="item.title" /></a>
            <a v-else href="javascript:void(0)" onclick=zixun()><img :src="item.img" :alt="item.title" /></a>
        </div>
    </swiperTop> -->
    <!-- 引入公共端头部组件 -->
    <headNav></headNav>
    <!-- 搜索短期项目 -->
    <search @mysearch="isSearchFn($event)"></search>
    <div class="searchTextIsEmpty-box" v-show="searchTextIsEmpty">
        <!-- 颜色盒子 -->
        <div class="ban-color-wrap">
            <!-- 首页banner区域 初始化过早问题，绑定数据的长度值 -->
            <swiper :key="banners.length">
                <div class="swiper-slide" v-for="item in banners" :key="item.id" >
                    <a v-if="item.src != null" :href="item.src"><img :src="item.img" :alt="item.title" /></a>
                    <a v-else href="javascript:void(0)" onclick=zixun()><img :src="item.img" :alt="item.title" /></a>
                </div>
            </swiper>
            <div class="ban-color-bottom"></div>
        </div>
        <!-- navban导航 -->
        <navban id="home-nav">
            <li v-for="item in navs" :key="item.id" slot="navabanli">
                <a v-if="item.src != null" :href="item.src">
                    <i :style="{'background': iconImg(item.img)}"></i>
                    <h3 v-cloak>{{item.title}}</h3>
                </a>
                <a v-else href="javascript:void(0)" onclick=zixun()>
                    <i :style="{'background': iconImg(item.img)}"></i>
                    <h3 v-cloak>{{item.title}}</h3>
                </a>
            </li>
        </navban>
        <!-- 试学 -->
        <section class="ad-bg-wrap">
            <a href="tel:0871-65812999">
                <img src="/assets/img/home/ixion/free-icon.png" alt="电话咨询">
            </a>
        </section>
        <!-- 试学 -->
        <!-- <section class="ad-bg-wrap">
            <a href="javascript:void(0)" onclick="zixun()">
                <img src="/assets/img/home/ixion/double-11-ban.png" alt="11优惠活动">
            </a>
        </section> -->
        <!-- 宣传横幅 -->
        <section class="streamer-wrap">
            <ul>
                <li v-for="item in streamers" :key="item.id">
                    <a v-if="item.src != null" :href="item.src"><img :src="item.img" :alt="item.title" /></a>
                    <a v-else href="javascript:void(0)" onclick=zixun()><img :src="item.img" :alt="item.title" /></a>
                </li>
            </ul>
        </section>
        <!-- 短期专业 -->
        <section class="public-radius-wrap open-shop-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>热门创业专业</h3>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0)" @click.stop="hotChange">+更多</a> -->
                        <a href="javascript:void(0)" onclick="zixun()">+更多</a>
                    </li>
                </ul>
            </div>
            <!-- <div class="public-radius-box dq-major-box">
                <ul>
                    <li v-for="item in dqMajor" :key="item.id">
                        <a  class="dq-major-img" v-if="item.src != null" :href="item.src">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <a v-else class="hotstup-img" :href="item.src" onclick="zixun()">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <div class="dq-major-info">
                            <div class="dq-major-box">
                                <h3>{{item.title}}</h3>
                                <p>{{item.des}}</p>
                                <div class="dq-major-btn">
                                    <a v-if="item.src != null" :href="item.src">专业详情</a>
                                    <a v-else href="javascript:void(0)" onclick="zixun()">专业详情</a>
                                    <a href="javascript:void(0)" onclick="zixun()">咨询学费</a>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <a class="public-zixun" onclick="zixun()" href="javascript:void(0)">在线查看更多专业&gt;&gt;</a>
            </div> -->
            <div class="public-radius-box public-radius-ul">
                <!-- <ul> -->
                <transition-group tag="ul" name="openShop" mode="out-in">
                    <li v-for="item in dqMajor" :key="item.id">
                        <a  class="hotstup-img" v-if="item.src != null" :href="item.src">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <a v-else class="hotstup-img" :href="item.src" onclick="zixun()">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <div class="hotstup-info">
                            <div class="hotstup-box">
                                <h3>{{item.title}}</h3>
                                <h4>{{item.subtitle}}</h4>
                                <p>{{item.des}}</p>
                            </div>
                        </div>
                    </li>
                </transition-group>
            </div>
        </section>
        <!-- 小吃流动摊创业 -->
        <section class="public-radius-wrap open-shop-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>小吃流动摊创业</h3>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0)" @click.stop="hotChange">+更多</a> -->
                        <a href="javascript:void(0)" onclick="zixun()">+更多</a>
                    </li>
                </ul>
            </div>
            <div class="public-radius-box public-radius-ul">
                <!-- <ul> -->
                <transition-group tag="ul" name="" mode="out-in">
                    <li v-for="item in openShop02" :key="item.id">
                        <a  class="hotstup-img" v-if="item.src != null" :href="item.src">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <a v-else class="hotstup-img" :href="item.src" onclick="zixun()">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <div class="hotstup-info">
                            <div class="hotstup-box">
                                <h3>{{item.title}}</h3>
                                <h4>{{item.des}}</h4>
                                <p>已有{{randomNumber(1000,3000)}}人报名</p>
                            </div>
                        </div>
                    </li>
                </transition-group>
                 <!-- <li>
                        <a class="hotstup-img" href="javascript:void(0)">
                            <img src="/assets/img/home/hot-item/hot-1/1.jpg" alt="干锅火锅">
                        </a>
                        <div class="hotstup-info">
                            <div class="hotstup-box">
                                <h3>火锅培训</h3>
                                <h4>味道正宗</h4>
                                <p>已有{{randomNumber(1000,3000)}}人报名</p>
                            </div>
                        </div>
                    </li>
                </ul> -->
                <!-- 数据加载完 没有更多的样式 -->
                <!-- <a @click="hotShowMore" ref="hotMore" :class="['show-more-item',{'show-moreEnd-item':isMore}]" href="javascript:void(0)">在线查看更多项目&gt;&gt;</a> -->
                <!-- <a class="public-zixun" onclick="zixun()" href="javascript:void(0)">在线查看更多项目&gt;&gt;</a> -->
            </div>
        </section>
        <!-- 夜宵排挡创业 -->
        <section class="public-radius-wrap open-shop-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>夜宵排挡创业</h3>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0)" @click.stop="hotChange">+更多</a> -->
                        <a href="javascript:void(0)" onclick="zixun()">+更多</a>
                    </li>
                </ul>
            </div>
            <div class="public-radius-box public-radius-ul">
                <!-- <ul> -->
                <transition-group tag="ul" name="" mode="out-in">
                    <li v-for="item in openShop03" :key="item.id">
                        <a  class="hotstup-img" v-if="item.src != null" :href="item.src">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <a v-else class="hotstup-img" :href="item.src" onclick="zixun()">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <div class="hotstup-info">
                            <div class="hotstup-box">
                                <h3>{{item.title}}</h3>
                                <h4>{{item.des}}</h4>
                                <p>已有{{randomNumber(1000,3000)}}人报名</p>
                            </div>
                        </div>
                    </li>
                </transition-group>
            </div>
        </section>
        <!-- 外卖创业 -->
        <section class="public-radius-wrap open-shop-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>外卖创业</h3>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0)" @click.stop="hotChange">+更多</a> -->
                        <a href="javascript:void(0)" onclick="zixun()">+更多</a>
                    </li>
                </ul>
            </div>
            <div class="public-radius-box public-radius-ul">
                <!-- <ul> -->
                <transition-group tag="ul" name="" mode="out-in">
                    <li v-for="item in openShop04" :key="item.id">
                        <a  class="hotstup-img" v-if="item.src != null" :href="item.src">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <a v-else class="hotstup-img" :href="item.src" onclick="zixun()">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <div class="hotstup-info">
                            <div class="hotstup-box">
                                <h3>{{item.title}}</h3>
                                <h4>{{item.des}}</h4>
                                <p>已有{{randomNumber(1000,3000)}}人报名</p>
                            </div>
                        </div>
                    </li>
                </transition-group>
            </div>
        </section>
        <!-- 云南特色小吃创业 -->
        <section class="public-radius-wrap open-shop-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>云南特色小吃创业</h3>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0)" @click.stop="hotChange">+更多</a> -->
                        <a href="javascript:void(0)" onclick="zixun()">+更多</a>
                    </li>
                </ul>
            </div>
            <div class="public-radius-box public-radius-ul">
                <!-- <ul> -->
                <transition-group tag="ul" name="" mode="out-in">
                    <li v-for="item in openShop05" :key="item.id">
                        <a  class="hotstup-img" v-if="item.src != null" :href="item.src">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <a v-else class="hotstup-img" :href="item.src" onclick="zixun()">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <div class="hotstup-info">
                            <div class="hotstup-box">
                                <h3>{{item.title}}</h3>
                                <h4>{{item.des}}</h4>
                                <p>已有{{randomNumber(1000,3000)}}人报名</p>
                            </div>
                        </div>
                    </li>
                </transition-group>
            </div>
        </section>
        <!-- 西点西餐创业 -->
        <section class="public-radius-wrap open-shop-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>西点西餐创业</h3>
                    </li>
                    <li>
                        <!-- <a href="javascript:void(0)" @click.stop="hotChange">+更多</a> -->
                        <a href="javascript:void(0)" onclick="zixun()">+更多</a>
                    </li>
                </ul>
            </div>
            <div class="public-radius-box public-radius-ul">
                <!-- <ul> -->
                <transition-group tag="ul" name="" mode="out-in">
                    <li v-for="item in openShop06" :key="item.id">
                        <a  class="hotstup-img" v-if="item.src != null" :href="item.src">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <a v-else class="hotstup-img" :href="item.src" onclick="zixun()">
                            <img :src="item.img" :alt="item.title">
                        </a>
                        <div class="hotstup-info">
                            <div class="hotstup-box">
                                <h3>{{item.title}}</h3>
                                <h4>{{item.des}}</h4>
                                <p>已有{{randomNumber(1000,3000)}}人报名</p>
                            </div>
                        </div>
                    </li>
                </transition-group>
            </div>
        </section>
        <!-- 实操教学 -->
        <section class="public-radius-wrap practical-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>实操教学<span>新手可学、不限学时</span></h3>
                    </li>
                    <li>
                        <a href="javascript:void(0)" onclick="zixun()">+更多</a>
                    </li>
                </ul>
            </div>
            <div class="practical-box">
                <navban>
                    <li v-for="enItem in envir" :key="enItem.id" slot="navabanli">
                        <a href="javascript:void(0)">
                            <img :src="enItem.img" />
                        </a>
                        <h3>{{enItem.title}}</h3>
                    </li>
                </navban>
            </div>
            <a class="public-zixun" onclick="zixun()" href="javascript:void(0)">在线预约到校参观试吃</a>
        </section>
        <!-- 学短期优势 -->
        <section class="public-radius-wrap lean-advan-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>新东方优势<span>36年、专注烹饪教育</span></h3>
                    </li>
                    <li>
                        <a href="javascript:void(0)" onclick="zixun()">+更多</a>
                    </li>
                </ul>
            </div>
            <div class="lean-advan-box">
                <!-- 学短期优势列表 -->
                <navban>
                    <li v-for="item in advs" :key="item.id" slot="navabanli">
                        <a href="javascript:void(0)">
                            <i :style="{'background': iconImg(item.icon)}"></i>
                            <h3 v-cloak>{{item.title}}</h3>
                            <p v-html="item.p"></p>
                        </a>
                    </li>
                </navban>
                <a class="public-zixun" onclick="zixun()" href="javascript:void(0)">预约优惠名额</a>
            </div>
        </section>
        <!-- 师资力量 -->
        <section class="public-radius-wrap teachers-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>师资力量<span>专注、更专业</span></h3>
                    </li>
                </ul>
            </div>
            <div class="public-radius-box teachers-img-box">
                <a href="javascript:void(0)">
                    <img src="/assets/img/home/teachers/one.jpg" alt="中餐教师合集">
                </a>
            </div>
            <div class="teachers-des">
                <p>
                    云南新东方烹饪学校作为职业培训学校中的佼佼者，拥有一支素质高、技术强、教学精的教师队伍。
                </p>
            </div>
            <a class="public-zixun" onclick="zixun()" href="javascript:void(0)">咨询开班时间</a>
        </section>
        <!-- 创业指导 -->
        <section class="public-radius-wrap kd-case-wrap">
            <!-- 公共栏目头部 -->
            <div class="public-home-head">
                <ul>
                    <li>
                        <h3>创业指导<span>八大帮扶、助你创业</span></h3>
                    </li>
                    <li>
                        <a href="javascript:void(0)" @click.stop="kdcaseChange">+更多</a>
                    </li>
                </ul>
            </div>
            <section class="public-radius-box kd-case-title \">
                <ul>
                    <li>
                        <h3>创业<span>培训体系</span></h3>
                        <p>通过创业意识培训和创业模拟实训两大工程授创业实务。</p>
                    </li>
                    <li>
                        <h3>创业<span>帮扶体系</span></h3>
                        <p>对有创业愿望的学生提供八大创业帮扶。</p>
                    </li>
                </ul>
            </section>
            <!-- 开店案例 -->
            <!-- <section class="public-radius-box kd-case-box">
                <transition-group tag="ul" name="hotItemActive" mode="out-in">
                    <li v-for="item in kdCasesRecommendItems" :key="item.id">
                        <a :href="item.src" onclick="zixun()" v-if="item.src != null">
                            <img :src="item.img" />
                            <h3 v-cloak>{{item.h3}}</h3>
                            <p v-cloak>{{item.addr}}</p>
                        </a>
                        <a href="javascript:void(0)" onclick="zixun()" v-else>
                            <img :src="item.img" />
                            <h3 v-cloak>{{item.h3}}</h3>
                            <p v-cloak>{{item.addr}}</p>
                        </a>
                    </li>
                </transition-group>
                <a class="public-zixun" onclick="zixun()" href="javascript:void(0)">预约创业帮扶名额</a>
            </section> -->
        </section>
    </div>
    <!-- 公共底footer栏 -->
    <publicFoot></publicFoot>
</div>
</template>

<script>
// import swiperTop from "@/components/SwiperTop" // 头部滚动区域
import headNav from "@/components/HeadNav"
import swiper from "@/components/Swiper" // banner轮播区域
import search from "@/components/Search" // 搜索区域
import navban from "@/components/Navban" // nav 导航
import publicFoot from "@/components/PublicFoot" // foot 底部

import baseMixin from "@/mixins/baseMixin";

import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper-bundle.min.css'

export default {
    name: "home",
    mixins: [baseMixin], // 注入mixin
    data() {
        return {
            scrollBanners: [], // 首页滚动横幅
            banners: [], // 首页banner
            navs: [], // 首页栏目导航
            iconImg(img) { // 导航图标
                return `url(${img}) no-repeat center / contain`
            },
            streamers: [], // 广告横幅
            searchTextIsEmpty: true, // 默认没有搜索，其他内容显示
            isMore: false, //  控制是否有更多热门 创业项目
            dqMajor: [], // 短期专业
            openShop02:[], // 小吃流动摊创业
            openShop03:[], // 夜宵排挡创业
            openShop04:[], // 外卖创业
            openShop05:[], // 云南特色小吃创业
            openShop06:[], // 西点西餐创业
            hotIndex: 1, // 热门创业项目 换一换
            hotRecommendItems: [], // 默认显示
            advs: [], // 短期优势
            envir: [], // 教学环境
            kdCases: [], // 创业开店案例
            kdCasesIndex: 1, // 创业开店案例 换一换
            kdCasesRecommendItems: [ ]// 默认显示
        }
    },
    components: {
        // swiperTop,
        headNav,
        search,
        swiper,
        navban,
        publicFoot
    },
    methods: {
        /* 热门创业项目 换一换*/
        // hotChange() {
        //     // this.hotRecommendItems = this.getRandomArrayElements(this.hots, 8);
        //     var This = this;
        //     this.hotIndex++;
        //     if(this.hotIndex > 3){
        //         this.hotIndex = 1;
        //     }
        //     switch(this.hotIndex){
        //         case 1:
        //             This.hotRecommendItems = This.hots.slice(0,8);
        //             break;
        //         case 2:
        //             This.hotRecommendItems = This.hots.slice(8,16);
        //             break;
        //         case 3:
        //             This.hotRecommendItems = This.hots.slice(16);
        //             break;
        //     }
        // },
        /* 热门创业项目 查看更多*/
        // hotShowMore() {
        //     this.hotRecommendItems = this.hots;
        // },
        /* 创业开店案例 换一换*/
        kdcaseChange() {
            // this.kdCasesRecommendItems = this.getRandomArrayElements(this.kdCases, 6);
            var This = this;
            this.kdCasesIndex++;
            if(this.kdCasesIndex > 2){
                this.kdCasesIndex = 1;
            }
            switch(this.kdCasesIndex){
                case 1:
                    This.kdCasesRecommendItems = This.kdCases.slice(0,4);
                    break;
                case 2:
                    This.kdCasesRecommendItems = This.kdCases.slice(4,8);
                    break;
                case 3:
                    This.kdCasesRecommendItems = This.kdCases.slice(8,12);
                    break;
            }
        },
        /* 本地获取数据 */
        getLocalDataByFetch(callBack){
            fetch('/assets/json/home.json')
                .then((res) => {
                    return res.json();
                })
                .then((data) => {
                    callBack && callBack(data);
                })
        },
        getCurList(id){ // 根据id词获取当前数据
            var This = this;
            this.getLocalDataByFetch(function(data){
                This.list = This.filterDataType(data.fondData,'food');
                This.curList = This.list.filter((item)=>{
                    return item.id.indexOf(id) != -1
                })
            })
        },
        isSearchFn(e){ // 是否点击了搜索
            // console.log(e);
            if(e == ''){
                this.searchTextIsEmpty = true;
            }else{
                this.searchTextIsEmpty = false; // 隐藏其他内容来显示搜索的结果
            }
        },
        randomNumber(x,y){
            return parseInt( Math.random()*(y-x)+x );
        }
    },
    mounted() {
        var This = this;
        this.getLocalDataByFetch(function(data){
            // console.log(data.homeData);
            This.scrollBanners = This.filterDataType(data.homeData,'scrollBanner');

            This.banners = This.filterDataType(data.homeData,'banner');
            This.navs = This.filterDataType(data.homeData,'nav');
            This.streamers = This.filterDataType(data.homeData,'streamer');

            This.dqMajor = This.filterDataType(data.homeData,'dq-major'); // 短期专业

            This.openShop02 = This.filterDataType(data.homeData,'open-shop-2'); // 小吃流动摊创业
            This.openShop03 = This.filterDataType(data.homeData,'open-shop-3'); // 夜宵排挡创业
            This.openShop04 = This.filterDataType(data.homeData,'open-shop-4'); // 外卖创业
            This.openShop05 = This.filterDataType(data.homeData,'open-shop-5'); // 云南特色小吃创业
            This.openShop06 = This.filterDataType(data.homeData,'open-shop-6'); // 西点西餐创业
            // This.hotRecommendItems = This.hots.slice(0,6); // 热门创业项目 默认显示

            This.envir = This.filterDataType(data.homeData,'envir'); // 教学环境

            This.advs = This.filterDataType(data.homeData,'advantage'); // 短期优势

            // This.kdCases = This.filterDataType(data.homeData,'case'); // 创业开店案例
            // This.kdCasesRecommendItems = This.kdCases.slice(0,4); // 创业开店案例 默认显示
        })
        new Swiper('.teachers-img-box',{
            direction: 'horizontal', // 水平切换选项
            loop: true, // 循环模式选项
            effect : 'slide',
            autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: false
            }
        });
    },
    updated(){
        // 控制是否有更多热门 创业项目
        // if( this.hotRecommendItems.length == this.hots.length ){
        //     this.$refs.hotMore.innerHTML = "没有更多啦";
        //     this.isMore = true;
        // }else{
        //     this.$refs.hotMore.innerHTML = "在线查看更多项目&gt;&gt;";
        //     this.isMore = false;
        // }
    }
};
</script>

<style lang="less">
// 初始化设计图尺寸 注意：less 除法要用小括号括起来
@rem: 40rem;
@w100: (640/@rem);
.justify {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.auto(@w) {
    width: (@w/@rem);
    margin: 0 auto;
}
// 圆角
.radius(@radius) {
    border-radius: (@radius/@rem) (@radius/@rem) (@radius/@rem) (@radius/@rem);
}
.linefont(@lineHeight, @fontSize, @color) {
    line-height: (@lineHeight/@rem);
    font-size: (@fontSize/@rem);
    color: @color;
}
.backgroundUrl(@img) {
    background: url(@img) no-repeat center / contain;
}
.aimg(@h) {
    a {
        display: block;
        img {
            width: 100%;
            height: (@h/@rem);
        }
    }
}
// vue闪烁问题
[v-cloak] {
    display: none;
}
.searchTextIsEmpty-box{
    background: #f1f1f1;
}
.ban-color-wrap{
    background: #ffd5d5;
    padding-bottom: (15/@rem);
    position: relative;
    .ban-color-bottom{
        width: 100%;
        height: (89/@rem);
        position: absolute;
        bottom: -1px;
        left: 50%;
        transform: translateX(-50%);
        .backgroundUrl('/assets/img/home/ixion/ban-color-bottom.jpg')
    }
}
// navban导航
#home-nav {
    margin-top: (20/@rem);
    margin-bottom: (20/@rem);
    ul {
        .auto(600);
        background: #fff;
        .radius(10);
        
        li {
            width: 140/@rem;
            margin-top: 20/@rem;

            a {
                display: block;

                i {
                    display: block;
                    .auto(79);
                    height: 79/@rem;
                }

                h3 {
                    .linefont(50, 20, #000);
                    text-align: center;
                }
            }
            &:nth-of-type(1),
            &:nth-of-type(2){
                h3{
                    color: #fe0000;
                    position: relative;
                    &::before{
                        content: '';
                        display: block;
                        width: 6/@rem;
                        height: 6/@rem;
                        .radius(3);
                        background: #fe0000;
                        position: absolute;
                        top: 50%;
                        left: 14/@rem;
                        transform: translateY(-50%);
                    }
                }
            }
            &:nth-of-type(8){
                h3{
                    color: #fe0000;
                }
            }
        }
    }
}
// 宣传横幅
.streamer-wrap{
    ul{
        li{
            a {
                display: block;
                img {
                    width: 100%;
                }
            }
        }
    }
}
// 公共栏目头部
.public-home-head {
    .auto(580);
    ul {
        &:extend(.justify);
        li {
            h3 {
                .linefont(80, 28, #000);
                letter-spacing: (3/@rem);
                font-weight: 600;
                text-indent: (25/@rem);
                position: relative;
                span {
                    .linefont(80, 18, #ec1f1e);
                    margin-left: (5/@rem);
                }
                &::before {
                    content: '';
                    display: block;
                    width: 0px;
                    height: 0px;
                    border-left: (15/@rem) solid #fd3c00;
                    border-top: (10/@rem) solid transparent;
                    border-right: (10/@rem) solid transparent;
                    border-bottom: (10/@rem) solid transparent;
                    position: absolute;
                    top: 50%;
                    left: 0px;
                    transform: translateY(-50%);
                }
            }
            a {
                display: block;
                width: 110/@rem;
                .linefont(30, 19, #f74f52);
                text-align: center;
                border: 1px solid #f74f52;
                .radius(18);
                margin-top: 25/@rem;
            }
        }
    }
}
// 公共模块层
.public-radius-wrap{
    .auto(610);
    background: #fff;
    padding-bottom: (15/@rem);
    .radius(15);
    .public-radius-box{
        .auto(580);
    }
    .public-radius-ul{
        ul {
            &:extend(.justify);
            li {
                width: (185/@rem);
                .aimg(140);
                .radius(10);
                margin-bottom: (20/@rem);
                box-shadow: 0 0 3px 2px #e2e2e2;
                .hotstup-info {
                    padding-bottom: (10/@rem);
                    text-align: center;
                    h3 {
                        .linefont(36, 20, #000);
                        font-weight: bold;
                    }
                    h4{
                        .linefont(36, 20, #575757);
                    }
                    p {
                        .linefont(30, 20, #ff0c0c);
                    }
                }
            }
        }
    }
}
// 短期专业
.dq-major {
    .dq-major-box{
        ul {
            &:extend(.justify);
            li {
                width: (270/@rem);
                .aimg(168);
                border: 1px solid #000;
                .radius(10);
                margin-bottom: 20/@rem;
                .dq-major-info {
                    padding-bottom: (20/@rem);
                    .dq-major-box {
                        .auto(262);
                    }

                    h3 {
                        .linefont(36, 24, #000);
                        text-align: center;
                    }

                    p {
                        .linefont(30, 20, #737373);
                        text-align: center;

                        span {
                            .linefont(30, 20, #ea0510);
                        }
                    }
                    .dq-major-btn{
                        .auto(245);
                        &:extend(.justify);
                        margin-top: (15/@rem);
                        a {
                            display: block;
                            width: (114/@rem);
                            .linefont(36, 22, #d83538);
                            border: 1px solid #d83538;
                            .radius(6);
                            &:last-child{
                                background: #d83538;
                                color: #fff;
                            }
                        }
                    }
                    
                }
            }
        }
    }
}
// 热门创业项目
.open-shop-wrap {
    margin-top: (30/@rem);
    // .show-more-item {
    //     display: block;
    //     .auto(570);
    //     .linefont(60, 22, #fff);
    //     background: linear-gradient(to right, #f75052 30%, #d83538);
    //     .radius(30);
    // }
    // .show-moreEnd-item{ // 数据加载完 没有更多的样式
    //     background: #eeeeee;
    //     color: #737373;
    // }
}
// 热门创业项目【进入】动画效果
.hotItemActive-enter-active{
    animation: backInLeft .5s .2s;
}
// 热门创业项目【离开】动画效果
.hotItemActive-leave-active{
    // animation: bounceOutRight .5s reverse;
    animation: backOutDown .5s;
}
// 学短期优势
.lean-advan-wrap{
    margin-top: (20/@rem);
    .navban-component{
        .auto(580);
    }
    .lean-advan-box {
        ul{
            li {
                width: 270/@rem;
                height: 164/@rem;
                background: #eeeeee;
                position: relative;
                margin-top: 50/@rem;
                .radius(20);

                h3 {
                    margin-top: 30/@rem;
                    .linefont(60, 30, #d83538);
                    font-weight: bold;
                }

                p {
                    .linefont(30, 20, #000);
                }

                i {
                    display: block;
                    width: 60/@rem;
                    height: 60/@rem;
                    position: absolute;
                    top: -30/@rem;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
    }
    .public-zixun{
        margin-top: (25/@rem);
    }
}
// 公共咨询
.public-zixun {
    .auto(570);
    display: block;
    .linefont(60, 22, #fff);
    background: linear-gradient(to right, #f75052 30%, #d83538);
    .radius(30);
}
// 实操教学
.practical-wrap {
    margin-top: (30/@rem);
    .practical-box{
        .navban-component{
            .auto(580);
        }
        ul {
            li {
                width: (283/@rem);
                .aimg(187);
                h3{
                    .linefont(60, 20, #000);
                    font-weight: 500;
                    text-align: center;
                }
            }
        }
    }
    .public-zixun {
        margin-top: 0;
    }
}
// 免费试学
.ad-bg-wrap {
    a {
        display: block;

        img {
            width: 100%;
        }
    }
}
// 师资力量
.teachers-wrap{
    .auto(620);
    background: #fff;
    margin-top: (20/@rem);
    padding-bottom: (30/@rem);
    .radius(10);
    .teachers-img-box{
        .auto(600);
        a{
            display: block;
            img{
                display: block;
                width: 100%;
            }
        }
    }
    .teachers-des{
        .auto(600);
        margin-top: (15/@rem);
        padding-bottom: (20/@rem);
        p{
            .linefont(36, 22, #000);
            text-align: justify;
        }
    }
}
// 开店案例
.kd-case-wrap {
    margin-top: (30/@rem);
    .kd-case-title{
        ul{
            &:extend(.justify);
            li{
                width: (248/@rem);
                border: 2px solid #d83538;
                .radius(5);
                padding: (10/@rem) (10/@rem);
                h3{
                    .linefont(30, 22, #000);
                    font-weight: bold;
                    text-align: left;
                    span{
                        .linefont(25, 22, #d83538);
                        font-weight: bold;
                    }
                }
                p{
                    .linefont(30, 19, #464646);
                    text-align: justify;
                }
            }
        }
    }
    .kd-case-box{
        margin-top: (20/@rem);
        ul {
            &:extend(.justify);
            li {
                width: 280/@rem;
                .aimg(188);
                margin-bottom: 20/@rem;
                a{
                    img{
                        .radius(10);
                    }
                }
               
                h3 {
                    .linefont(38, 24, #000);
                }

                p {
                    .linefont(30, 20, #646464);
                }
            }
        }
    }
}
@keyframes bounce-in{
    0%{
        opacity: 0;
        transform: scale(.3) translateY(100%);
    }
    100%{
        opacity: 1;
        transform: scale(1)  translateY(0);
    }
}
@keyframes backOutDown {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }

  20% {
    -webkit-transform: translateY(0px) scale(0.7);
    transform: translateY(0px) scale(0.7);
    opacity: 0.7;
  }

  100% {
    -webkit-transform: translateY(700px) scale(0.7);
    transform: translateY(700px) scale(0.7);
    opacity: 0.7;
  }
}
@keyframes backInLeft {
  0% {
    -webkit-transform: translateX(-2000px) scale(0.7);
    transform: translateX(-2000px) scale(0.7);
    opacity: 0.7;
  }

  80% {
    -webkit-transform: translateX(0px) scale(0.7);
    transform: translateX(0px) scale(0.7);
    opacity: 0.7;
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
</style>